import { render, staticRenderFns } from "./AnomalousDetails.vue?vue&type=template&id=09c2e88f&scoped=true"
import script from "./AnomalousDetails.vue?vue&type=script&lang=js"
export * from "./AnomalousDetails.vue?vue&type=script&lang=js"
import style0 from "./AnomalousDetails.vue?vue&type=style&index=0&id=09c2e88f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c2e88f",
  null
  
)

export default component.exports